import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import { allEnumValues } from "./helper.js";
import { ItemTaxationStatus } from "./item_taxation_status.js";
//#region src/item_taxation_status_helper.ts
var item_taxation_status_helper_exports = /* @__PURE__ */ __exportAll({
	allValuesForMenuItems: () => allValuesForMenuItems,
	allValuesForMods: () => allValuesForMods,
	name: () => name
});
function name(taxationStatus) {
	switch (taxationStatus) {
		case 0: return "Taxable";
		case 1: return "Tax Included";
		case 2: return "Not Taxable";
		case 3: return "Inherit";
	}
}
function allValuesForMenuItems() {
	return allEnumValues(ItemTaxationStatus).filter((taxationStatus) => {
		return taxationStatus !== 3;
	});
}
function allValuesForMods() {
	return allEnumValues(ItemTaxationStatus);
}
//#endregion
export { allValuesForMenuItems, allValuesForMods, item_taxation_status_helper_exports, name };

//# sourceMappingURL=item_taxation_status_helper.js.map